module.exports = __webpack_public_path__ + "assets/images/peixeboi_6cf63b859fcd648d445723beb7e5289d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stage-helps/peixeboi.png
// module id = 283
// module chunks = 0